/**
 * TotalCostRisk colors.
 * TODO: Get these from the design system when available. Figma spec: spreadCost/tempCost = #F05536B8, risk = #DA9846B8.
 */
export const TOTAL_COST_RISK_COLORS = {
  spreadCost: '#F05536B8',
  tempCost: '#F05536B8',
  risk: '#DA9846B8',
} as const;
